import { startGcpHostingDemoStreamLoop } from './gcpHostingDemoStreamLoop.js'

/**
 * @typedef {{
 *   tid: string,
 *   pendingId: string,
 *   signal: AbortSignal,
 *   session: ReturnType<import('../streamSession.js').createAssistantStreamSession>,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 * }} GcpHostingStreamCtx
 */

/** @param {GcpHostingStreamCtx} ctx */
export function runGcpHostingDemoStream(ctx) {
  startGcpHostingDemoStreamLoop(ctx)
}
